import ButtonContainer from '@@viewCommonComponents/forms/ButtonContainer.jsx';
import { useState } from 'react';
import { Icon, Message, PageTitle, ProductCard } from '@fasstech/middle-design-system';
import { isNilOrEmpty, mapIndexed } from '@@serverHelpers/index.mjs';
import useSimulationProductForm from './hooks/useSimulationProductForm.js';
import { prop, propOr } from 'ramda';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';

const SimulationProductForm = ({ getSimulationProduct, getMiddleText }) => {
  const [showNoticeError, setShowNoticeError] = useState(false);
  const {
    products,
    updateSelectedProduct,
    loadingProductIndex,
    selectedProduct,
    $onPrevClick,
    handleLoadNotices,
    getProductImage
  } = useSimulationProductForm({
    getSimulationProduct,
    setShowNoticeError
  });

  return (
    <>
      <PageLayout withFormLayout={false} className=" flex-col items-center gap-y-6 ">
        <Icon name={'product'} size={70} />
        <PageTitle>{getMiddleText('PRODUCTS_VIEW_TITLE')}</PageTitle>
        {showNoticeError && (
          <Message
            variant="error"
            className="mb-2 text-sm"
            label={getMiddleText('PRODUCTS_DOCUMENT_UNAVAILABLE_ERROR_MESSAGE')}
          />
        )}
        <div className="flex flex-wrap gap-x-3 gap-y-4 mb-8 justify-center">
          {mapIndexed((product, index) => {
            return (
              <ProductCard
                key={propOr(`product-${index}`, 'id', product)}
                title={prop('name', product)}
                description={prop('description', product)}
                onArrowClick={() => updateSelectedProduct(index)}
                onDownloadClick={() => handleLoadNotices(prop('code', product))}
                image={getProductImage(product)}
                noticeCode={getMiddleText('PRODUCTS_DOCUMENTS_LINK_LABEL')}
                isActive={prop('isSelected', product)}
                loading={loadingProductIndex === index}
              />
            );
          })(products)}
        </div>
      </PageLayout>
      <ButtonContainer
        $onPreviousButtonClick={$onPrevClick}
        isFormError={isNilOrEmpty(selectedProduct)}
        nextButtonIsHidden={true}
        displayResumeButton
        getMiddleText={getMiddleText}
      />
    </>
  );
};

export default SimulationProductForm;
